import { Text } from '@ui/atoms';

const Notes = ({ note1, note2 }) => (
    <div className="flex flex-col gap-4 text-gray-500 p6-regular">
        <Text content={note1} className="text-left" />
        <Text content={note2} className="text-left" />
    </div>
);

export default Notes;
